module.exports = __webpack_public_path__ + "img/gestao_municipal_bronze.2933bebc.png";